export default "__VITE_ASSET__Bpwke0$Z__"